import React from "react";

const DashboardSection = ({ title, subtitle, action, children, className = "" }) => (
  <section className={`dashboard-panel ${className}`.trim()}>
    <div className="dashboard-panel__header">
      <div>
        <div className="dashboard-panel__title">{title}</div>
        {subtitle && <div className="dashboard-panel__subtitle">{subtitle}</div>}
      </div>
      {action}
    </div>
    <div className="dashboard-panel__body">{children}</div>
  </section>
);

export default DashboardSection;
